import Vue from "vue";
import App from "./App.vue";
import store from "./store/store";
import router from "./router";
import vuetify from "./plugins/vuetify";

import "@/assets/css/style.scss";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
